import { useEffect } from 'react';
import getGeoZone from '../services/getGeoZone/index.js';

function useGeoZone(onGeoZoneFound) {
  useEffect(function () {
    getGeoZone().then(function (geoZone) {
      if (geoZone === null || geoZone === void 0 ? void 0 : geoZone.country_code) {
        onGeoZoneFound(geoZone.country_code);
      } else {
        throw new Error();
      }
    })["catch"](function () {
      return console.error('Geozone not found');
    });
  }, [onGeoZoneFound]);
}

export { useGeoZone as default };
//# sourceMappingURL=index.js.map
